import React from 'react';
import Import from '../../pages/Import';

export default function ImportViewContainer({ onOpenUpload }) {
  return <Import onUploadClick={onOpenUpload} />;
}
